export default __webpack_public_path__ + "static/mascot_welcome_logo-334ee79abbedea2ce2fc562aaae7fde9.webp";